import { Box, Container, Typography, styled } from '@mui/material';
import React from 'react';

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.common.white,
}));

const SectionHeading = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif !important',
  fontWeight: 600,
  fontSize: '2rem',
  color: '#181D27',
  marginBottom: theme.spacing(2.5),
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    fontSize: '2.25rem',
  },
}));

const SectionText = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  color: '#535862',
  textAlign: 'center',
  maxWidth: '800px',
  margin: '0 auto',
}));

const RedefiningFutureSection: React.FC = () => (
  <SectionWrapper>
    <Container maxWidth="lg">
      <SectionHeading>Redefining the Future of Property Management</SectionHeading>

      <SectionText>
        Revolutionizing property management by leveraging artificial intelligence to streamline
        operations, boost efficiency, and enhance tenant experiences.
      </SectionText>
    </Container>
  </SectionWrapper>
);

export default RedefiningFutureSection;
